import React, { useState } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { VscNewFile, VscSearch } from 'react-icons/vsc';
import { checkMot } from '../../../../ressources/functionJS/checkMot';
import * as type_btn from '../../../../ressources/glossaires/glossaire_type_de_bouton';
import { convertiUtsToDateHour } from '../../../InterfaceClient/Tabs/Alarmes/TableauAlarmesClient/TableauAlarmesClient';
import Bouton from '../../../UI/Bouton/Bouton';
import { Sensor } from '../../../../types/types';

// Définition des interfaces

interface Props {
  selectionnerLignes?: any;
  defaultSorted?: Array<{ dataField: string; order: string }>;
  data: Sensor[];
}

const TableauComposantMaintenance = (props: Props) => {
  const [columns, setColumns] = useState({
    columns: [
      {
        dataField: 'detection_timestamp',
        text: [checkMot('detection_timestamp')],
        sort: true,
        formatter: (cell: number) => {
          if (!cell) return '';
          return convertiUtsToDateHour(cell);
        },
      },
      {
        dataField: 'timestamp_last_value',
        text: [checkMot('timestamp_last_value')],
        sort: true,
        formatter: (cell: number) => {
          if (!cell) return '';
          return convertiUtsToDateHour(cell);
        },
      },
      {
        dataField: 'position_in_sensor',
        text: [
          'Position ',
          <Bouton
            key={'position_in_sensor'}
            type={type_btn.lupeSearch}
            cliquer={() =>
              afficherFiltre(
                'position_in_sensor',
                checkMot('position_in_sensor')
              )
            }
          >
            <VscSearch size={10} />
          </Bouton>,
        ],
        sort: true,
      },

      {
        dataField: 'prefix',
        text: [
          'Prefix',
          <Bouton
            key={'prefix'}
            type={type_btn.lupeSearch}
            cliquer={() => afficherFiltre('prefix', checkMot('prefix'))}
          >
            <VscSearch size={10} />
          </Bouton>,
        ],
        sort: true,
      },
    ],
    selectRow: {
      // paramètre d'affichage des lignes du tableau
      mode: 'radio',
      clickToSelect: true,
      hideSelectAll: true,
      hideSelectColumn: true,
      style: () => {
        //style après sélection
        return {
          background: '#eeb214',
          color: 'black',
        };
      },
    },
    iconeCreer: <VscNewFile size={15} />,
  });

  const afficherFiltre = (dataField: string, placeholder: string) => {
    const newCol = columns.columns.map((col) => {
      if (col.dataField === dataField) {
        return {
          ...col,
          filter: textFilter({
            placeholder: placeholder,
          }),
        };
      } else {
        return col;
      }
    });
    setColumns((prevColumns) => ({ ...prevColumns, columns: newCol }));
  };

  // Définition des options de pagination
  const options = {
    sizePerPageList: [
      {
        text: '10',
        value: 10,
      },
      {
        text: '15',
        value: 15,
      },
    ],
  };
  return (
    <BootstrapTable
      data={props.data}
      columns={columns.columns}
      keyField={'id'}
      striped
      hover
      condensed
      selectRow={props.selectionnerLignes}
      rowStyle={{ marginLeft: '0px' }}
      filter={filterFactory()}
      pagination={paginationFactory(options)}
      bordered={true}
    />
  );
};

export default TableauComposantMaintenance;
